// Auto-generated by Storyline Creator (Vite)

export default {
  "id": "the_notice",
  "title": "The Notice",
  "coverImage": "",
  "requirements": [
    {
      "type": "flag",
      "key": "accept_trinket",
      "eq": true
    }
  ],
  "startScene": "start",
  "scenes": {
    "start": {
      "steps": [
        {
          "type": "page",
          "image": "/images/the_notice_1.png",
          "text": "Click to continue."
        },
        {
          "type": "choice",
          "image": "/images/the_notice_2.png",
          "left": {
            "label": "Accept.",
            "if": [],
            "effects": [
              {
                "type": "sanity",
                "delta": 2
              },
              {
                "type": "gainTrinketRandom",
                "count": 1,
                "pool": "any"
              },
              {
                "type": "flag",
                "key": "accept_trinket2",
                "value": true
              }
            ],
            "nextScene": "end",
            "nextStorylet": "the_doubt"
          },
          "right": {
            "label": "Decline.",
            "if": [],
            "effects": [
              {
                "type": "flag",
                "key": "accept_trinket2",
                "value": false
              }
            ],
            "nextScene": "scene_1",
            "nextStorylet": "the_warning"
          },
          "prompt": "Drag to choose."
        }
      ]
    },
    "scene_1": {
      "steps": [
        {
          "type": "page",
          "image": "/images/the_notice_4.png",
          "text": "Click to continue."
        },
        {
          "type": "ending",
          "image": "/images/the_notice_5.png",
          "effects": [],
          "text": "Click to end."
        }
      ]
    },
    "end": {
      "steps": [
        {
          "type": "ending",
          "image": "/images/the_notice_3.png",
          "effects": [],
          "text": "Click to end."
        }
      ]
    }
  }
};
